import colors from 'Styles/colors';
import './variables.scss';

function getSeverityColor (value) {
  switch (value) {
    case 'critical':
      return colors.warmPurple;
    case 'high':
      return colors.redPink;
    case 'medium':
      return colors.tangerine;
    case 'med':
      return colors.tangerine;
    case 'low':
      return colors.apple;
    case 'informational':
      return colors.grey2;
    case 'info':
      return colors.grey2;
    case 'unclassified':
      return colors.grey4;
    default:
      return colors.grey4;
  }
}

export const severitySelect = (theme) => ({
  control: (provided, state) => ({
    height: '34px',
    borderRadius: '2px',
    boxShadow: `2px 2px 5px 0 ${theme.shadows.actionDropDown}`,
    border: `solid 1px ${getSeverityColor(state.getValue()[0].value)}`,
    backgroundColor: state.getValue()[0] ? getSeverityColor(state.getValue()[0].value) : theme.backgrounds.actionDropDown,
    color: theme.text.severitiesDropdown,
    left: '16px',
    width: '148px'
  }),

  valueContainer: () => ({
    padding: '7px 8px 2px 8px',
    color: theme.text.severitiesDropdown
  }),

  clearIndicator: () => ({
    display: 'none'
  }),

  indicatorSeparator: () => ({
    // display: 'none'
    background: 'red'
  }),

  dropdownIndicator: () => ({
    position: 'absolute',
    top: '3px',
    right: '11px'
  }),

  option: (provided, state) => ({
    ...provided,
    fontSize: '14px',
    textAlign: 'left',
    color: theme.text.actionDropDownItem,
    cursor: state.isSelected ? 'default' : 'pointer',
    paddingLeft: '22px',
    height: '36px',
    textTransform: 'none',
    fontWeight: state.selectProps.value.value === state.value ? 500 : 300,
    backgroundColor: state.isFocused ? theme.backgrounds.dropdown1OptionsHover : theme.backgrounds.dropdown1Options
  }),

  menu: () => ({
    position: 'absolute',
    marginTop: '6px',
    zIndex: 5000,
    width: '100%',
    border: 'none',
    borderRadius: '3px',
    backgroundColor: theme.backgrounds.actionDropDown,
    boxShadow: `2px 2px 30px 0 ${theme.shadows.actionDropDown}`,
    minWidth: '190px'
  }),

  menuList: () => ({
    maxHeight: '250px',
    overflowX: 'auto',
    borderRadius: '3px',
    paddingTop: '17px',
    paddingBottom: '13px'
  }),

  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return {
      ...provided, opacity, transition, color: theme.text.severitiesDropdown, width: 'fit-content', height: '21px', fontSize: '13.5px', fontWeight: 500, left: '12px', textTransform: 'capitalize'
    };
  }
});

export const basicSelect = (theme) => ({
  control: () => ({
    height: '34px',
    border: `solid 1px ${theme.borders.actionDropDown}`,
    backgroundColor: theme.backgrounds.actionDropDown,
    boxShadow: theme.boxShadow.dropdown,
    left: '16px',
    fontSize: '12.5px',
    fontWeight: '500',
    color: theme.text.eorDropdown,
    width: '162px'
  }),

  indicatorSeparator: () => ({
    display: 'none'
  }),

  dropdownIndicator: () => ({
    position: 'absolute',
    top: '7px',
    right: '6px',
    color: theme.text.eorDropdownIcon
  }),

  option: (provided, state) => ({
    ...provided,
    // backgroundColor: state.isSelected ? '#f1f4f7' : 'white',
    fontSize: '14px',
    textAlign: 'left',
    cursor: state.isSelected ? 'default' : 'pointer',
    paddingLeft: '22px',
    height: '36px',
    fontWeight: state.selectProps.value.value === state.value ? 900 : 400,
    color: theme.text.actionDropDownItem,
    backgroundColor: state.isFocused ? theme.backgrounds.dropdown1OptionsHover : theme.backgrounds.dropdown1Options
  }),

  menu: () => ({
    position: 'absolute',
    zIndex: 5000,
    border: 'none',
    borderRadius: '3px',
    backgroundColor: theme.backgrounds.dropdown1Options,
    boxShadow: `2px 2px 30px 0 ${theme.shadows.actionDropDown}`,
    minWidth: '150px',
    width: '100%'
  }),

  valueContainer: () => ({
    height: '34px',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '16px',
    color: theme.text.eorDropdown
  }),

  menuList: () => ({
    maxHeight: '250px',
    overflowX: 'auto',
    borderRadius: '3px',
    paddingTop: '17px',
    paddingBottom: '13px'
  }),

  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return {
      ...provided, opacity, transition, color: theme.text.eorDropdown, width: 'fit-content', fontSize: '13.5px', fontWeight: 500
    };
  }
});

// Modal Dropdown styles
export const severityDropdownStyle = (theme) => ({
  control: (provided, state) => ({
    backgroundColor: state.getValue()[0] ? getSeverityColor(state.getValue()[0].value) : theme.textfield.background,
    height: '35px',
    width: '160px',
    borderRadius: '2px',
    color: 'white',
    paddingLeft: '10px',
    fontWeight: '700',
    boxShadow: theme.boxShadow.dropdown
  }),

  indicatorSeparator: () => ({
    display: 'none'
  }),

  placeholder: () => ({
    fontSize: '13px',
    color: theme.text.placeholder,
    position: 'relative',
    fontWeight: 400
  }),

  dropdownIndicator: (provided, state) => ({
    ...provided,
    position: 'absolute',
    top: '0px',
    right: '4px',
    color: state.hasValue ? 'white' : '#515a65',
    width: '30px'
  }),

  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? theme.backgrounds.actionDropDownHover : theme.backgrounds.actionDropDown,
    color: theme.text.actionDropDownItem,
    fontSize: '14px',
    textAlign: 'left',
    cursor: state.isSelected ? 'default' : 'pointer',
    paddingLeft: '22px',
    height: '36px',
    textTransform: 'none',
    fontWeight: state.isSelected ? 600 : 300
  }),

  valueContainer: () => ({
    height: '33px',
    display: 'flex',
    alignItems: 'center'
  }),

  menu: () => ({
    position: 'absolute',
    marginTop: '6px',
    zIndex: 5000,
    width: '100%',
    border: 'none',
    borderRadius: '3px',
    backgroundColor: theme.backgrounds.dropdown1Options,
    boxShadow: `2px 2px 30px 0 ${theme.shadows.actionDropDown}`,
    minWidth: '190px'
  }),

  menuList: () => ({
    maxHeight: '250px',
    overflowX: 'auto',
    borderRadius: '3px',
    paddingTop: '17px',
    paddingBottom: '13px'
  }),

  input: () => ({
    paddingTop: '2px',
    color: 'white'
  }),

  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return {
      ...provided, opacity, transition, color: theme.text.actionDropDownTitle, width: 'fit-content', height: '100%', display: 'flex', alignItems: 'center', fontSize: '14px', fontWeight: 400, maxWidth: 'calc(100% - 24px)'
    };
  }
});

export const severityDropdownStyleKB = (theme) => {
  const base = severityDropdownStyle(theme);

  return {
    ...base,
    control: (provided, state) => ({
      ...base.control(provided, state),
      height: '38px'
    })
  };
};

export const eorDropdownStyle = (theme) => ({
  control: () => ({
    height: '35px',
    width: '228px',
    borderRadius: '2px',
    boxShadow: theme.boxShadow.dropdown,
    borderColor: theme.borders.actionDropDown,
    color: 'white',
    paddingLeft: '10px',
    fontWeight: '700',
    borderWidth: '0px',
    borderStyle: 'solid',
    backgroundColor: theme.textfield.background
  }),

  indicatorSeparator: () => ({
    display: 'none'
  }),

  placeholder: () => ({
    fontSize: '13px',
    color: theme.text.placeholder,
    position: 'relative',
    fontWeight: 400
  }),

  dropdownIndicator: (provided) => ({
    ...provided,
    position: 'absolute',
    top: '0px',
    right: '4px',
    color: '#515a65',
    width: '30px'
  }),

  valueContainer: () => ({
    height: '33px',
    display: 'flex',
    alignItems: 'center'
  }),

  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? theme.backgrounds.actionDropDownHover : theme.backgrounds.actionDropDown,
    color: theme.text.actionDropDownItem,
    fontSize: '14px',
    textAlign: 'left',
    cursor: state.isSelected ? 'default' : 'pointer',
    paddingLeft: '22px',
    height: '36px',
    textTransform: 'none',
    fontWeight: state.isSelected ? 600 : 300
  }),

  menu: () => ({
    backgroundColor: theme.backgrounds.actionDropDown,
    boxShadow: `2px 2px 30px 0 ${theme.shadows.actionDropDown}`,
    position: 'absolute',
    marginTop: '6px',
    zIndex: 5000,
    width: '100%',
    border: 'none',
    borderRadius: '3px',
    minWidth: '190px'
  }),

  menuList: () => ({
    maxHeight: '250px',
    overflowX: 'auto',
    borderRadius: '3px',
    paddingTop: '17px',
    paddingBottom: '13px'
  }),

  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return {
      ...provided, opacity, transition, color: theme.text.actionDropDownTitle, width: 'fit-content', height: '21px', fontSize: '14px', fontWeight: 400, maxWidth: 'calc(100% - 24px)'
    };
  }
});

export const eorDropdownStyleKB = (theme) => {
  const base = eorDropdownStyle(theme);

  return {
    ...base,
    control: (provided, state) => ({
      ...base.control(provided, state),
      height: '38px'
    })
  };
};

export const groupSelect = {
  control: () => ({
    width: '175px',
    height: '34px',
    opacity: 0.6,
    borderRadius: '2px',
    boxShadow: '2px 2px 5px 0 rgba(0, 0, 0, 0.06)',
    border: 'solid 1px #dbdbdb',
    backgroundColor: '#ffffff',
    cursor: 'pointer'
  }),

  indicatorSeparator: () => ({
    display: 'none'
  }),

  dropdownIndicator: () => ({
    position: 'absolute',
    top: '4px',
    right: '20px',
    width: '6px',
    color: '#8da6be'
  }),

  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused || state.isSelected ? '#f1f4f7' : 'white',
    fontSize: '14px',
    textAlign: 'left',
    color: '#1c2243',
    cursor: state.isSelected ? 'default' : 'pointer',
    paddingLeft: '22px',
    height: '36px',
    fontWeight: 300
  }),

  menu: () => ({
    position: 'absolute',
    zIndex: 5000,
    border: 'none',
    borderRadius: '3px',
    backgroundColor: '#fff',
    boxShadow: '2px 2px 30px 0 #d5dee6',
    minWidth: '150px',
    width: '100%'
  }),

  valueContainer: () => ({
    width: '96px',
    height: '26px',
    fontSize: '12px',
    fontWeight: 300,
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#1c2243',
    marginLeft: '13px'
  }),

  menuList: () => ({
    maxHeight: '250px',
    overflowX: 'auto',
    borderRadius: '3px',
    paddingTop: '17px',
    paddingBottom: '13px'
  }),

  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return {
      ...provided, opacity, transition, color: '#1c2243', width: 'fit-content', fontSize: '12px', fontWeight: 300, left: '16px'
    };
  }
};

export const statusSelect = (theme, lightTheme) => ({
  control: () => ({
    height: '34px',
    border: `solid 1px ${theme.borders.actionDropDown}`,
    backgroundColor: theme.backgrounds.actionDropDown,
    boxShadow: theme.boxShadow.dropdown,
    left: '16px',
    fontSize: '12.5px',
    fontWeight: 500,
    color: '#082731',
    width: '155px'
  }),

  indicatorSeparator: () => ({
    display: 'none'
  }),

  dropdownIndicator: (provided, state) => {
    const children = state.selectProps.value.label;
    const color = () => {
      if (children === 'Re-Opened' && lightTheme) return '#e26464';
      if (children === 'Risk-Accepted' && lightTheme) return colors.apple;
      if (children === 'Open' && lightTheme) return colors.warmPurple;
      if (children === 'Closed' && lightTheme) return '#90a9c0';
      return colors.grey71;
    };

    return {
      position: 'absolute',
      top: '7px',
      right: '6px',
      color: color()
    };
  },

  option: (provided, state) => {
    const { children } = state;
    const color = () => {
      if (children === 'Re-Opened') return '#e26464';
      if (children === 'Risk-Accepted') return colors.apple;
      if (children === 'Open') return colors.warmPurple;
      if (children === 'Closed') return '#90a9c0';
      return colors.grey17;
    };

    return {
      ...provided,
      fontSize: '14px',
      textAlign: 'left',
      color: color(),
      cursor: state.isSelected ? 'default' : 'pointer',
      paddingLeft: '22px',
      height: '36px',
      fontWeight: state.selectProps.value.value === state.value ? 900 : 400,
      backgroundColor: state.isFocused ? theme.backgrounds.dropdown1OptionsHover : theme.backgrounds.dropdown1Options
    };
  },

  menu: () => ({
    position: 'absolute',
    zIndex: 5000,
    border: 'none',
    borderRadius: '3px',
    minWidth: '150px',
    width: '100%',
    backgroundColor: theme.backgrounds.dropdown1Options,
    boxShadow: `2px 2px 30px 0 ${theme.shadows.actionDropDown}`
  }),

  valueContainer: () => ({
    height: '34px',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '16px',
    color: theme.text.actionDropDownItem
  }),

  menuList: () => ({
    maxHeight: '250px',
    overflowX: 'auto',
    borderRadius: '3px',
    paddingTop: '17px',
    paddingBottom: '13px'
  }),

  singleValue: (provided, state) => {
    const { children } = state;
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    const color = () => {
      if (children === 'Re-opened') return '#e26464';
      if (children === 'Risk-accepted') return colors.apple;
      if (children === 'Open') return colors.warmPurple;
      if (children === 'Closed') return '#90a9c0';
      return colors.white2;
    };
    return {
      ...provided, opacity, transition, color: color(), width: 'fit-content', fontSize: '13.5px', fontWeight: 600
    };
  }
});

export const standardDropdownStyle = (theme, maxHeight, width) => ({
  control: () => ({
    height: '35px',
    width: width || '227px',
    borderRadius: '1px',
    backgroundColor: theme.selector.background,
    boxShadow: theme.shadows.standardDropdown,
    borderWidth: '1px 0px 0px 1px',
    borderSstyle: 'solid',
    borderColor: `${theme.borders.actionDropDown}`,
    color: theme.selector.text,
    paddingLeft: '10px',
    fontWeight: '700',
    textOverflow: 'ellipsis'
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  placeholder: () => ({
    fontSize: '13px',
    color: theme.selector.text,
    position: 'relative',
    fontWeight: 400
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    position: 'absolute',
    top: '0px',
    right: '4px',
    color: theme.selector.text,
    width: '30px'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? theme.backgrounds.actionDropDownHover : theme.backgrounds.actionDropDown,
    fontSize: '14px',
    textAlign: 'left',
    color: theme.text.actionDropDownItem,
    cursor: state.isSelected ? 'default' : 'pointer',
    paddingLeft: '22px',
    paddingRight: '22px',
    height: '36px',
    textTransform: 'none',
    textOverflow: 'ellipsis',
    fontWeight: state.isSelected ? 600 : 300,
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  }),
  valueContainer: () => ({
    height: '33px',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden', // 👈 clave
    flex: 1, // 👈 deja que ocupe todo el ancho disponible
    minWidth: 0
  }),
  menu: () => ({
    position: 'absolute',
    marginTop: '6px',
    zIndex: 5000,
    width: '100%',
    border: 'none',
    borderRadius: '3px',
    backgroundColor: theme.backgrounds.actionDropDown,
    boxShadow: `2px 2px 30px 0 ${theme.shadows.actionDropDown}`,
    minWidth: '190px'
  }),
  menuList: () => ({
    maxHeight: maxHeight || '110px',
    overflowX: 'auto',
    borderRadius: '3px'
  }),
  input: (provided) => ({
    ...provided,
    paddingTop: '2px',
    color: theme.selector.text
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return {
      ...provided, opacity, transition, color: theme.selector.text, width: 'fit-content', height: '19px', fontSize: '14px', fontWeight: 400, position: 'relative', maxWidth: 'calc(100% - 24px)', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'
    };
  }
});

export const textfieldDropdownStyle = (theme) => ({
  container: (provided) => ({
    ...provided,
    width: '100%'
  }),
  control: () => ({
    display: 'flex',
    height: '34px',
    width: '100%',
    backgroundColor: theme.textfield.background,
    boxShadow: theme.shadows.agentSelectorInScheduler,
    border: '1px solid transparent',
    borderBottom: 'none',
    color: theme.textfield.text,
    paddingLeft: '10px',
    fontWeight: 300,
    textOverflow: 'ellipsis'
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: theme.textfield.text,
    width: '30px'
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: '14.5px',
    color: theme.text.taskPlaceholder,
    fontWeight: 300
  }),
  singleValue: (provided, state) => ({
    ...provided,
    opacity: state.isDisabled ? 0.5 : 1,
    color: theme.textfield.text,
    fontSize: '14.5px',
    fontWeight: 300,
    maxWidth: 'calc(100% - 24px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: '34px',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    flex: 1,
    minWidth: 0
  }),
  input: (provided) => ({
    ...provided,
    color: theme.textfield.text,
    fontSize: '14.5px',
    fontWeight: 300
  }),
  menu: () => ({
    position: 'absolute',
    marginTop: '4px',
    zIndex: 5000,
    width: '100%',
    borderRadius: '3px',
    backgroundColor: theme.backgrounds.actionDropDown,
    boxShadow: `2px 2px 30px 0 ${theme.shadows.actionDropDown}`,
    minWidth: '190px'
  }),
  menuList: () => ({
    maxHeight: '200px',
    overflowY: 'auto',
    borderRadius: '3px',
    paddingTop: '8px',
    paddingBottom: '8px'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? theme.backgrounds.actionDropDownHover : theme.backgrounds.actionDropDown,
    fontSize: '14px',
    color: theme.text.actionDropDownItem,
    cursor: state.isSelected ? 'default' : 'pointer',
    paddingLeft: '22px',
    paddingRight: '22px',
    height: '36px',
    fontWeight: state.isSelected ? 600 : 300,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  })
});

function getUserRoleColor (value) {
  switch (value) {
    case 'asset_owner':
      return '#53a9ff';
    case 'client':
      return '#0082ed';
    case 'pentester':
      return '#ea3158';
    case 'admin':
      return '#a4247a';
    case 'workspace_admin':
      return colors.green3;
    default:
      return '#82add1';
  }
}

export const UserRoleDropdownStyle = (theme, width = '190px') => ({
  container: (provided, state) => ({
    height: '34px',
    width,
    cursor: state.isDisabled ? 'not-allowed' : 'pointer'
  }),

  control: (provided, state) => ({
    border: 'none',
    display: 'flex',
    fontSize: '13.5px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: theme.text.usersDropdown,
    // padding: '1px 8px',
    boxShadow: state.menuIsOpen ? `0 2px 50px 0 ${theme.shadows.actionDropDown}` : '',
    height: '34px',
    width
  }),

  placeholder: () => ({
    color: theme.text.usersDropdown,
    top: '7px',
    textAlign: 'left',
    position: 'relative',
    marginLeft: '12px'
  }),

  indicatorSeparator: () => ({
    display: 'none'
  }),

  indicatorsContainer: () => ({
    bottom: '3px',
    color: theme.text.usersDropdown,
    position: 'relative'
  }),

  dropdownIndicator: (provided) => ({
    ...provided,
    position: 'absolute',
    top: '2px',
    right: '2px',
    color: theme.text.usersDropdown,
    width: '30px'
  }),

  valueContainer: (provided, state) => ({
    height: '34px',
    width,
    fontSize: '13.5px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    textAlign: 'center',
    color: theme.text.usersDropdown,
    position: 'relative',

    borderRadius: '2px',
    boxShadow: `2px 2px 5px 0 rgba(0, 0, 0, 0.06), inset 0 -2px 0 0 ${state.getValue()[0] === undefined ? '#63758d' : getUserRoleColor(state.getValue()[0].value)}`,
    border: 'solid 1px',
    borderColor: state.getValue()[0] === undefined ? '#63758d' : getUserRoleColor(state.getValue()[0].value),
    backgroundColor: state.getValue()[0] === undefined ? '#63758d' : getUserRoleColor(state.getValue()[0].value)
  }),

  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? theme.backgrounds.actionDropDownHover : theme.backgrounds.actionDropDown,
    fontSize: '13.5px',
    textAlign: 'left',
    color: theme.selector.text,
    cursor: 'pointer',
    paddingLeft: '22px',
    paddingRight: '10px',
    height: '40px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }),

  menu: () => ({
    position: 'absolute',
    zIndex: 5000,
    width,
    maxWidth: width,
    height: '191px',
    border: 'none',
    borderRadius: '3px',
    backgroundColor: theme.backgrounds.actionDropDown,
    boxShadow: `0 2px 50px 0 ${theme.shadows.actionDropDown}`
  }),

  menuList: () => ({
    maxHeight: '143px',
    height: '191px',
    borderRadius: '3px',
    paddingTop: '15px',
    paddingBottom: '12px'
  }),

  singleValue: (provided, state) => ({
    marginTop: '-6px',
    opacity: state.isDisabled ? 0.5 : 1,
    transition: 'opacity 300ms',
    position: 'absolute',
    bottom: '7px',
    left: '12px',
    right: '28px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  })
});

export const groupSelectContext = (theme) => ({
  control: (provided, state) => {
    const children = state.selectProps.value[0].label;
    const width = () => {
      if (children === 'None') return '140px';
      return '175px';
    };
    return {
      width: width(),
      height: '34px',
      opacity: 0.6,
      borderRadius: '2px',
      boxShadow: '2px 2px 5px 0 rgba(0, 0, 0, 0.06)',
      border: 'solid 1px #dbdbdb',
      backgroundColor: theme.backgrounds.actionDropDown,
      cursor: 'pointer'
    };
  },

  indicatorSeparator: () => ({
    display: 'none'
  }),

  dropdownIndicator: () => ({
    position: 'absolute',
    top: '4px',
    right: '20px',
    width: '6px',
    color: '#8da6be'
  }),

  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused || state.isSelected ? theme.backgrounds.actionDropDown : theme.backgrounds.actionDropDownHover,
    fontSize: '14px',
    textAlign: 'left',
    color: theme.text.actionDropDownItem,
    cursor: state.isSelected ? 'default' : 'pointer',
    paddingLeft: '22px',
    height: '36px',
    fontWeight: 300
  }),

  menu: () => ({
    position: 'absolute',
    zIndex: 5000,
    border: 'none',
    borderRadius: '3px',
    backgroundColor: theme.backgrounds.actionDropDown,
    boxShadow: `2px 2px 30px 0 ${theme.shadows.actionDropDown}`,
    minWidth: '150px',
    width: '100%'
  }),

  valueContainer: () => ({
    width: '96px',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    fontWeight: 300,
    letterSpacing: 'normal',
    textAlign: 'center',
    color: theme.text.actionDropDownItem,
    marginLeft: '13px'
  }),

  menuList: () => ({
    maxHeight: '250px',
    overflowX: 'auto',
    borderRadius: '3px',
    paddingTop: '17px',
    paddingBottom: '13px'
  }),

  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return {
      ...provided, opacity, transition, color: theme.text.actionDropDownTitle, width: 'fit-content', fontSize: '12px', fontWeight: 300, left: '16px'
    };
  }
});

export const InputFilterGroupStyle = (theme) => ({
  container: () => ({
    'width': '0%',
    'height': '34px',
    'borderRadius': '1px',
    'boxShadow': `${theme.shadows.inputs}`,
    'backgroundColor': `${theme.textfield.background} !important`,
    'borderLeft': `solid 12px ${colors.softBlue}`,
    'borderBottomWidth': '0px',
    'borderRight': '1px solid transparent',
    'position': 'relative',
    '&:hover': {
      borderColor: `${theme.shadows.inputInset}`,
      borderLeftColor: `${colors.softBlue}`
    }

  }),
  control: () => ({
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: '34px',
    color: theme.selector.text,
    padding: '0 2px 0 10px',
    fontWeight: '700',
    textOverflow: 'ellipsis',
    backgroundColor: theme.textfield.background
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  placeholder: () => ({
    fontSize: '13px',
    color: theme.text.placeholder,
    position: 'relative',
    fontWeight: 300,
    height: '34px',
    lineHeight: '2.7'
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: theme.selector.text,
    width: '32px'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? theme.selector.background : theme.selector.selected,
    fontSize: '14px',
    textAlign: 'left',
    color: theme.selector.text,
    cursor: state.isSelected ? 'default' : 'pointer',
    paddingLeft: '22px',
    paddingRight: '22px',
    height: '36px',
    textTransform: 'none',
    textOverflow: 'ellipsis',
    fontWeight: state.isFocused ? 600 : 300,
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  }),
  valueContainer: () => ({
    width: '100%',
    position: 'relative'
  }),
  input: () => ({
    'width': '100%',
    'position': 'absolute',
    'top': '0',
    'color': theme.selector.text,
    'lineHeight': '2.3',
    '&:focus': {
      backgroundColor: theme.selector.background
    }
  }),
  menu: () => ({
    position: 'absolute',
    marginTop: '0',
    left: '-12px',
    top: '33px',
    zIndex: 5000,
    border: 'none',
    borderRadius: '3px',
    backgroundColor: theme.selector.background,
    boxShadow: `2px 2px 30px 0 ${theme.shadows.actionDropDown}`,
    minWidth: '190px'
  }),
  menuList: () => ({
    overflowX: 'auto',
    borderRadius: '3px',
    paddingTop: '17px',
    paddingBottom: '13px'
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return {
      ...provided, opacity, transition, color: theme.selector.text, width: 'fit-content', height: '19px', fontSize: '14px', fontWeight: 400, top: '8px', position: 'relative', maxWidth: 'calc(100% - 24px)'
    };
  }
});

export const standardDropdownStyleUnCapitalize = (theme) => ({
  ...standardDropdownStyle(theme),
  control: () => ({
    height: '35px',
    width: '200px',
    borderRadius: '1px',
    border: `solid 1px ${theme.borders.actionDropDown}`,
    backgroundColor: theme.backgrounds.actionDropDown,
    borderBottomWidth: '0px',
    color: 'white',
    paddingLeft: '10px',
    fontWeight: '700',
    textOverflow: 'ellipsis',
    boxShadow: `2px 2px 5px 0 ${theme.shadows.wsDropdown}, inset 0 -1px 0 0 ${theme.shadows.wsDropdownInset}`
  })
});

export const newDropdownStyle = (theme) => ({
  control: () => ({
    height: '35px',
    minWidth: '384px',
    borderRadius: '1px',
    boxShadow: `2px 2px 5px 0 rgba(0, 0, 0, 0.06), inset 0 -1px 0 0 ${theme.shadows.inputInset}`,
    backgroundColor: theme.backgrounds.actionDropDown,
    border: `solid 1px${theme.borders.actionDropDown}`,
    borderBottomWidth: '0px',
    borderRightWidth: '0px',
    color: 'white',
    paddingLeft: '10px',
    fontWeight: '700',
    textOverflow: 'ellipsis'
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  placeholder: () => ({
    fontSize: '13px',
    color: theme.selector.text,
    position: 'relative',
    fontWeight: 400
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    position: 'absolute',
    top: '0px',
    left: '352px',
    color: '#505965',
    width: '30px'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: 'red !important',
    fontSize: '14px',
    textAlign: 'left',
    color: theme.selector.text,
    cursor: state.isSelected ? 'default' : 'pointer',
    paddingLeft: '22px',
    paddingRight: '22px',
    height: '36px',
    textTransform: 'none',
    minWidth: '384px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontWeight: state.isSelected ? 600 : 300
  }),
  valueContainer: () => ({
    height: '33px',
    display: 'flex',
    alignItems: 'center'
  }),
  menu: () => ({
    marginTop: '6px',
    zIndex: 5000,
    width: '384px',
    border: 'none',
    borderRadius: '3px',
    backgroundColor: `${theme.selector.background}`,
    boxShadow: `2px 2px 30px 0 ${theme.textfield.shadow}`
  }),
  menuList: () => ({
    width: '384px',
    maxHeight: '152px',
    overflowX: 'auto',
    borderRadius: '3px',
    paddingTop: '17px',
    paddingBottom: '13px'
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return {
      ...provided, opacity, transition, color: theme.selector.text, width: 'fit-content', height: '19px', fontSize: '14px', fontWeight: 400, top: '8px', position: 'relative', maxWidth: 'calc(100% - 24px)'
    };
  }
});
